module.exports = __webpack_public_path__ + "static/img/2023.3.910be70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2023.3.jpg
// module id = 3xmg
// module chunks = 51